<script>
	export default {
		name: 'site-menu',
		data() {
			return {
			}
		},
		methods: {
			toggleSubMenu(e) {
				var $this = e.currentTarget;
				var $targets = $this.parentNode.children;

				Array.from($targets).forEach(function(el) {
				  el.classList.toggle('is-active');
				})
			}
		},
		computed: {
			isActive() {
				return {
					'is-active': this.$store.state.activeMenu
				}
			}
		},
		mounted() {
			/** Get the current page url */
			var url = window.location.pathname;
			var activePage = url.substring(url.lastIndexOf('/') + 1);

			/** Get all a tags within this component */
			var links = this.$el.getElementsByTagName('a');
			Array.from(links).forEach(function(link) {
				var linkPage = link.href.substring(link.href.lastIndexOf('/') + 1);
				if ( activePage == linkPage )
				{
					link.classList.add('is-current');
				}
			})
		}
	};
</script>



// WEBPACK FOOTER //
// site-menu.vue?286874e7